import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import { TrustpilotCarouselWidget } from '../TrustpilotCarouselWidget';
import styles from './TrustpilotSection.module.css';

export const TrustpilotSection = () => {
  return (
    <AboutUsModule background={'grey'}>
      <AboutUsSiteContainer>
        <div className={`${styles.container} ${styles.trustpilotSection}`}>
          <h2 className={`aboutUsTypographyHeaderXlarge ${styles.title}`}>
            <span className={styles.titleLine}>Rated</span>
            <span className={styles.titleLine}>{" 'Excellent'"}</span>
            <span className={`${styles.titleLine} ${styles.lastLine}`}>
              {' on Trustpilot'}
            </span>
          </h2>
          <TrustpilotCarouselWidget />
        </div>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};
